/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Image_Export_Success_ToastInputs */

const en_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Successfully exported ${i?.count} images and BDN script`)
};

const fr_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportation reussie de ${i?.count} images et du script BDN`)
};

const de_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-Bilder und BDN-Skript erfolgreich exportiert`)
};

const it_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Immagini ${i?.count} e script BDN esportati correttamente`)
};

const ru_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Изображения ${i?.count} и скрипт BDN успешно экспортированы.`)
};

const es_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se exportaron con éxito las imágenes ${i?.count} y el script BDN`)
};

const zh_cn2_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已成功导出 ${i?.count} 图像和 BDN 脚本`)
};

const ja_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 枚の画像と BDN スクリプトを正常にエクスポートしました`)
};

const hi_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} इमेज और बीडीएन स्क्रिप्ट सफलतापूर्वक निर्यात कर दी गई हैं।`)
};

const pt_pt2_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Imagens ${i?.count} e script BDN exportados com sucesso.`)
};

/**
* | output |
* | --- |
* | "Successfully exported {count} images and BDN script" |
*
* @param {Image_Export_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_success_toast = /** @type {((inputs: Image_Export_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_success_toast(inputs)
	if (locale === "de") return de_image_export_success_toast(inputs)
	if (locale === "it") return it_image_export_success_toast(inputs)
	if (locale === "ru") return ru_image_export_success_toast(inputs)
	if (locale === "es") return es_image_export_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_success_toast(inputs)
	if (locale === "ja") return ja_image_export_success_toast(inputs)
	if (locale === "hi") return hi_image_export_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_success_toast(inputs)
	return en_image_export_success_toast(inputs)
});